import { useEffect, useMemo, useState } from "react";

import { formatRelativeTime } from "~/utils/formatRelativeTime";

const TICK_MS = 10_000;

export const useLastUpdatedLabel = (timestamp?: string | null): string => {
  const timestampMs = useMemo(() => {
    if (!timestamp) return null;
    const ms = new Date(timestamp).getTime();
    return isNaN(ms) ? null : ms;
  }, [timestamp]);

  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!timestampMs) return;
    const id = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(id);
  }, [timestampMs]);

  return timestampMs
    ? `Updated ${formatRelativeTime(timestampMs, now)}`
    : "Updating…";
};
